import { render, staticRenderFns } from "./oilpalm-clusters-summary.vue?vue&type=template&id=1fe009ec&scoped=true&"
import script from "./oilpalm-clusters-summary.vue?vue&type=script&lang=js&"
export * from "./oilpalm-clusters-summary.vue?vue&type=script&lang=js&"
import style0 from "./oilpalm-clusters-summary.vue?vue&type=style&index=0&id=1fe009ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe009ec",
  null
  
)

export default component.exports